/* eslint-disable no-debugger */
import min from 'lodash/min';

import { COMMENT, OTHER } from '../attachments/constants';
import api from '../REST/api';
import createUiAction, { markUiAction } from '../utils/create-ui-action';
import storedUserInfo from '../utils/session-data/user-info';
import {
  getLatestTimestamp,
  transformForPatch,
} from './transform-comment-helpers';

export const initializeDiscussion = createUiAction(
  'comments/initialize',
  data => data,
);

async function piggyBackAttachmentUpload(comment) {
  const savedAttachments = await api.addAttachment({
    objectId: comment.id,
    contentType: COMMENT,
    type: OTHER,
  });

  return {
    ...comment,
    attachments: comment.attachments.concat(
      savedAttachments.map(attachment => attachment.response?.body),
    ),
  };
}

export const addComment = comment => (dispatch, getState) => {
  const { objectId, contentType } = getState().discussion.context;
  const user = storedUserInfo.get();

  return dispatch(
    markUiAction({
      type: 'comments/add-comment',
      payload: api
        .addComment({
          contentType,
          objectId,
          data: { ...comment, senderId: user.id },
        })
        .then(piggyBackAttachmentUpload),
    }),
  );
};
addComment.toString = () => 'comments/add-comment';

export const editComment = (id, updatedComment) => (dispatch, getState) => {
  const { contentType, objectId } = getState().discussion.context;
  const user = storedUserInfo.get();

  return dispatch(
    markUiAction({
      type: 'comments/edit-comment',
      payload: api
        .editComment({
          contentType,
          objectId,
          cId: id,
          data: {
            ...transformForPatch(updatedComment),
            senderId: user.id,
          },
        })
        .then(piggyBackAttachmentUpload),
    }),
  );
};
editComment.toString = () => 'comments/edit-comment';

export const poll = lastPoll => (dispatch, getState) => {
  const { contentType, objectId } = getState().discussion.context;
  // in case the user commented between the last poll and now.
  const newerThan = min([
    getLatestTimestamp(getState().discussion.comments),
    lastPoll,
  ]);

  return dispatch(
    markUiAction({
      type: 'comments/poll',
      payload: api.getComments({
        contentType,
        objectId,
        search: { newerThan },
      }),
    }),
  );
};
poll.toString = () => 'comments/poll';

export const updateComment = createUiAction(
  'comments/update-comment',
  updateCommentData => updateCommentData,
);
